import { css } from '@emotion/core';
import { pxToRem, styled, minimumWidth } from '@feast-it/ui/light';

export const StyledStatsGrid = styled.ul(
  ({ theme }) =>
    css`
      width: 100%;
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      column-gap: ${theme.spacing[4]};
      row-gap: ${theme.spacing[12]};

      ${minimumWidth(theme.breakpoints.large)} {
        flex-wrap: nowrap;
      }
    `
);

export const StyledStatContent = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing[3]};
    align-items: center;
    justify-content: center;
    min-width: ${pxToRem(200)};
  `
);
